import { render, staticRenderFns } from "./FundHoldingChart.vue?vue&type=template&id=5982e157&scoped=true"
import script from "./FundHoldingChart.vue?vue&type=script&setup=true&lang=js"
export * from "./FundHoldingChart.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FundHoldingChart.vue?vue&type=style&index=0&id=5982e157&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5982e157",
  null
  
)

export default component.exports